import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './components/App'

export const startStripeConnectRoyalties = data => {
  const root = createRoot(document.getElementById('sc_royalties'))
  root.render(
    <App
      coursenum={data.coursenum}
      royalties={data.royalties}
      isMaster={data.isMaster}
      childCount={data.childCount}
    />
  )
}
